/**
 * תצלומי הגלריה — Feedback1.md סעיפים 6.1א/7.2 (20.08.2026).
 *
 * ⭐ 9 קבצים סטטיים ב-`client/public/gallery-photos/`, נגזרים מ-`media for
 *    production/Backround images/` על ידי `tools/brand/build_gallery_assets.py`
 *    — אותו דפוס בדיוק כמו נכסי המותג (לוגו/favicon/OG). ⛔ **לא** תמונות
 *    מוצר (`product_media`) ו-⛔ **לא** בקטלוג (סעיף 0.16 - "מרכזייה למזגן
 *    מיני מרכזי"/"SLIM" אינן מוצרי קטלוג).
 *
 * 🔴 **התיקייה נקראת `gallery-photos`, ⛔ לא `gallery` — באג אמיתי שנתפס
 *    ותוקן בפרודקשן.** `client/public/gallery/` יצר תיקייה פיזית באותו
 *    נתיב בדיוק כמו הראוט `/gallery` — `express.static` (וגם ה-CDN של
 *    Hostinger מעליו) עונים ל-`GET /gallery` (בלי `/` בסוף) עם `301` ל-
 *    `/gallery/`, ⛔ **לפני** שהבקשה מגיעה בכלל ל-SPA fallback/ה-React
 *    Router. זה גרר שני נזקים אמיתיים: (1) הזרקת ה-SEO meta בצד השרת
 *    (`seoMeta.ts`, מפתח `STATIC_ROUTES['/gallery']` בלי `/` בסוף) לא
 *    התאימה יותר לנתיב עם ה-`/` שבסוף, ונפלה לברירת המחדל של דף הבית +
 *    `noindex`. (2) קפיצת ניווט מיותרת בכל קליק על "גלריה"/"עוד בגלריה".
 *    אומת חי: `curl -I https://noam-imd.co.il/gallery` (לפני התיקון) החזיר
 *    `301`+`noindex` בכותרת ה-canonical; אחרי המעבר ל-`gallery-photos` שני
 *    התסמינים נעלמו.
 *
 * ⭐ אותו מקור משמש גם לגלריית `GalleryPage.tsx` וגם לרקע ה-Hero
 *    (`HomePage.tsx`, סעיף 6.1א) — לא שני נכסים נפרדים.
 */

export interface GalleryImage {
  url: string;
  alt: string;
}

export const GALLERY_IMAGES: readonly GalleryImage[] = [
  {
    url: '/gallery-photos/plenum-01.jpg',
    alt: 'מרכזייה משולשת למזגן אוויר עם 6 יציאות, ייצור נועם ייבוא ושיווק',
  },
  { url: '/gallery-photos/plenum-02.jpg', alt: 'מרכזייה שטוחה למזגן אוויר עם 5 יציאות' },
  { url: '/gallery-photos/plenum-03.jpg', alt: 'מרכזייה משולשת למזגן אוויר עם 4 יציאות' },
  { url: '/gallery-photos/plenum-04.jpg', alt: 'מרכזייה משולשת למזגן אוויר עם 8 יציאות' },
  { url: '/gallery-photos/plenum-05.jpg', alt: 'מרכזייה SLIM מוארכת למזגן אוויר עם 3 יציאות' },
  { url: '/gallery-photos/plenum-06.jpg', alt: 'מרכזייה SLIM מוארכת למזגן אוויר, תצלום צד' },
  { url: '/gallery-photos/plenum-07.jpg', alt: 'מרכזייה משולשת קטנה למזגן אוויר עם 2 יציאות' },
  { url: '/gallery-photos/plenum-08.jpg', alt: 'מרכזייה משולשת קטנה למזגן אוויר עם 3 יציאות' },
  { url: '/gallery-photos/plenum-09.jpg', alt: 'מרכזייה שטוחה למזגן אוויר עם 6 יציאות בשורה' },
];

/**
 * ⭐ רקע ה-Hero (6.1א) — `plenum-04` (משולש 8 יציאות): צללית סימטרית שקוראת
 *    ברור גם בגודל רקע קטן ומטושטש-אור. הפילטר (brightness/saturate/opacity)
 *    מיושם ב-CSS ב-`HomePage.tsx`, ⛔ לא אפוי לקובץ עצמו — כדי שיישאר הפיך.
 */
export const HERO_BACKGROUND_IMAGE: GalleryImage =
  GALLERY_IMAGES[3] ?? (GALLERY_IMAGES[0] as GalleryImage);
